import type {
  NeuralSentenceVoice,
  SentencePace,
} from "@-/dev.improve.haniverse.lib.sentence.speech.voice-catalog";

export function synthesizeSentenceAudio(_options: {
  pace: SentencePace;
  sentence: string;
  voice: NeuralSentenceVoice;
}): Promise<string> {
  return Promise.reject(new Error("On-device voices are not available on the web"));
}

export function clearSentenceAudioCache(): void {}
